export default __webpack_public_path__ + "static/media/logo.d5f6ebb0.svg";